import React from "react";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404 ERROR!!!</h1>
      <h2>Page Not Found</h2>
    </div>
  );
};

export default NotFound;
